// eslint-disable-next-line import/no-unresolved
import MapBoxWrapper from './MapBoxWrapper';
export * from './models';

export default MapBoxWrapper; // react automatically resolves to platform specific wrapper
